import { render, staticRenderFns } from "./q2.vue?vue&type=template&id=40e1ce9a&scoped=true"
import script from "./q2.vue?vue&type=script&lang=js"
export * from "./q2.vue?vue&type=script&lang=js"
import style0 from "./q2.vue?vue&type=style&index=0&id=40e1ce9a&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40e1ce9a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\new-tis\\FR-TISSOT-IFB-Discovery-SFCC\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('40e1ce9a')) {
      api.createRecord('40e1ce9a', component.options)
    } else {
      api.reload('40e1ce9a', component.options)
    }
    module.hot.accept("./q2.vue?vue&type=template&id=40e1ce9a&scoped=true", function () {
      api.rerender('40e1ce9a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "cartridges/int_guidedProductFinder/cartridge/client/default/js/components/questionTemplates/q2.vue"
export default component.exports